/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentitySettingsListConfiguration,
    IdentitySettingsListConfigurationFromJSON,
    IdentitySettingsListConfigurationToJSON,
    IdentitySettingsListItem,
    IdentitySettingsListItemFromJSON,
    IdentitySettingsListItemToJSON,
    IdentitySettingsListQuery,
    IdentitySettingsListQueryFromJSON,
    IdentitySettingsListQueryToJSON,
} from '../models';

export interface ApiIdentitySettingsIdentitySettingsListDataPostRequest {
    identitySettingsListQuery?: IdentitySettingsListQuery;
}

/**
 * no description
 */
export class IdentitySettingsListApi extends runtime.BaseAPI {

    /**
     */
    async apiIdentitySettingsIdentitySettingsListConfigurationGetRaw(): Promise<runtime.ApiResponse<IdentitySettingsListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentitySettingsListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListConfigurationGet(): Promise<IdentitySettingsListConfiguration> {
        const response = await this.apiIdentitySettingsIdentitySettingsListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListDataPostRaw(requestParameters: ApiIdentitySettingsIdentitySettingsListDataPostRequest): Promise<runtime.ApiResponse<Array<IdentitySettingsListItem>>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentitySettings/IdentitySettingsList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentitySettingsListQueryToJSON(requestParameters.identitySettingsListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IdentitySettingsListItemFromJSON));
    }

    /**
     */
    async apiIdentitySettingsIdentitySettingsListDataPost(requestParameters: ApiIdentitySettingsIdentitySettingsListDataPostRequest): Promise<Array<IdentitySettingsListItem>> {
        const response = await this.apiIdentitySettingsIdentitySettingsListDataPostRaw(requestParameters);
        return await response.value();
    }

}
